import type { QuoteCarousel, QuoteFrameSource, QuoteSlide } from './types';

/**
 * The carousel-wide "Original / Editado" switch: sets `frameSource` and
 * re-targets every AUTOMATIC frame slide (`time === null`) at the new source
 * with `url: null`, so the capture hook grabs it again. Hand-picked frames
 * (`time !== null`) keep their own source, time and url; color and
 * background-less slides are untouched.
 */
export function applyCarouselFrameSource(
  carousel: QuoteCarousel,
  source: QuoteFrameSource,
): QuoteCarousel {
  if (carousel.frameSource === source) return carousel;
  const slides = carousel.slides.map((slide): QuoteSlide => {
    const bg = slide.background;
    if (bg?.kind !== 'frame' || bg.time !== null || bg.source === source) return slide;
    return {
      ...slide,
      background: {
        kind: 'frame', url: null, source, time: null,
      },
    };
  });
  return { ...carousel, frameSource: source, slides };
}
